import { ofType } from 'redux-observable';
import { switchMap } from 'rxjs/operators/switchMap';
import { map } from 'rxjs/operators/map';
import { catchError } from 'rxjs/operators/catchError';
import { WorkflowService } from '../../services';
import { types as actions, editedWorkflowAction } from '../../reducers/actions';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.EDIT_WORKFLOW),
    switchMap(action =>
      WorkflowService.edit(action.workflow, store).pipe(
        map(data => editedWorkflowAction(data)),
        catchError(retryAuthentication(action$, 'epics/workflows/editWorkflow'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/workflows/editWorkflow.js